import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
    state: IState;
    commit: Commit;
}

// 获取公告分页数据信息
const getNoticeList = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'announcement/getannouncementpaging',
        'POST',
        TYPES.GET_NOTICELIST_NAME,
        payload, false, apiRoot);
};

// 获取公告分页数据信息 -- 分类
const getNoticeListByType = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'announcement/getannouncementtypepaging',
        'POST',
        TYPES.GET_TYPE_NOTICELIST_NAME,
        payload, false, apiRoot);
};

// 获取公告详情
const getNoticeDetailById = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'announcement/getannouncementbyid',
        'GET',
        TYPES.GET_NOTICDETAIL_NAME,
        payload, false, apiRoot);
};

// 公告详情 -- 公告点赞
const praiseNotice = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'announcement/praiseannouncementbyid',
        'GET',
        TYPES.PRAISE_NOTICE_META,
        payload, false, apiRoot);
};

// 公告详情 -- 公告取消点赞
const cancelPraiseNotice = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'announcement/announcementpraisecancelbyid',
        'GET',
        TYPES.CANCEL_PRAISE_NOTICE_META,
        payload, false, apiRoot);
};

// 公告详情 -- 新增评论信息
const addNoticeComment = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'comment/addcomment',
        'POST',
        TYPES.ADD_NOTICE_COMMENT_META,
        payload, false, apiRoot);
};

// 公告详情 -- 删除评论
const delNoticeComment = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'comment/deletecommentbyid',
        'DELETE',
        TYPES.DEL_NOTICE_COMMENT_META,
        payload, false, apiRoot);
};

// 公告详情 -- 当前登录人是否有公告管理权限
const hasNoticePermission = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'announcement/haspermission',
        'GET',
        TYPES.HAS_NOTICE_PERMISSION_META,
        payload, false, apiRoot);
};

// 公告浏览量更新
const updateNoticeView = async (content: IActionContent, payload: object) => {
    await apiFetchAction(
        content.commit,
        'Announcement/AnnouncementViewById',
        'GET',
        TYPES.UPDATE_NOTICE_VIEW_META,
        payload, false, apiRoot);
};

export const actions = {
    getNoticeList,
    getNoticeListByType,
    getNoticeDetailById,
    praiseNotice,
    cancelPraiseNotice,
    addNoticeComment,
    delNoticeComment,
    hasNoticePermission,
    updateNoticeView
};
